import { IIssueSummaryResponse } from '@kcftech/prometheus-client';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVAL } from 'configs/constants';
import { sdClient } from 'contexts/SDKClientContext';

async function fetchLocationIssueMetrics(
    locationId: string,
): Promise<IIssueSummaryResponse> {
    try {
        return await sdClient.getIssueSummaryForLocation({
            locationId,
        });
    } catch (error) {
        throw new Error(
            `Failed to fetch metrics for location ${locationId}: ${
                error instanceof Error ? error.message : 'Unknown error'
            }`,
        );
    }
}

export function useLocationIssueMetrics(locationId: string) {
    return useQuery({
        queryKey: ['locationIssueMetrics', locationId],
        queryFn: () => fetchLocationIssueMetrics(locationId),
        refetchInterval: REFRESH_INTERVAL,
        placeholderData: keepPreviousData,
        staleTime: REFRESH_INTERVAL,
    });
}
